import React from "react";
import { auth, provider, database } from "../../firebase";
import LoginContext from "../../context/LoginContext";

import {
  Box,
  Flex,
  Text,
  Input,
  Button,
  Checkbox,
  Link
} from "@chakra-ui/react";

import { Link as NavLink } from "react-router-dom";
import NavBar from "../widgets/NavBar2";

export default function Login() {
  const isLogin = React.useContext(LoginContext);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const login = () => {
    auth
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        database
          .collection("users")
          .where("uid", "==", auth.currentUser.uid)
          .onSnapshot((snap) => {
            let val = snap.docs.map((doc) => ({
              id: doc.id
            }));

            if (val.length === 0) {
              // create user in the database.
              database.collection("users").add({
                uid: auth.currentUser.uid,
                name: auth.currentUser.displayName,
                email: auth.currentUser.email
              });
              isLogin.userInfo({
                displayName: auth.currentUser.displayName,
                email: auth.currentUser.email,
                photoUrl: auth.currentUser.photoURL
              });
              isLogin.login();
            } else {
              // user's document already created.
              isLogin.userInfo({
                displayName: auth.currentUser.displayName,
                email: auth.currentUser.email,
                photoUrl: auth.currentUser.photoURL
              });
              isLogin.login();
            }
          });
      })
      .catch(alert);
  };

  const googleSignin = () => {
    auth
      .signInWithPopup(provider)
      .then(function (result) {
        // checks if the user is new or not
        if (
          auth.currentUser.metadata.creationTime ===
          auth.currentUser.metadata.lastSignInTime
        ) {
          database.collection("users").add({
            name: auth.currentUser.displayName,
            email: auth.currentUser.email,
            photoUrl: auth.currentUser.photoURL
          });
        }
        console.log(auth.currentUser);
        isLogin.userInfo({
          displayName: auth.currentUser.displayName,
          email: auth.currentUser.email,
          photoUrl: auth.currentUser.photoURL
        });
        isLogin.login();
      })
      .catch(alert);
  };

  return (
    <Flex flexDirection="column">
      <NavBar />
      <Flex flexDirection="Column" align="center" height="600px" mt="10">
        <Text fontFamily="sans-serif" fontWeight="bold" fontSize="18" mt="10">
          Hello, welcome back to Astroworkers
        </Text>

        <Text
          fontFamily="sans-serif"
          fontWeight="bold"
          fontsize="18"
          marginTop={12}>
          Login
        </Text>

        <Input
          placeholder="Enter your email"
          type="email"
          width="310px"
          focusBorderColor="blue.500"
          marginTop={4}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Input
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              login();
            }
          }}
          placeholder="Enter your password"
          type="password"
          width="310px"
          focusBorderColor="blue.500"
          marginTop={4}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Flex
          width="310px"
          justifyContent="flex-end"
          style={{ backgroundColor: "white" }}>
          <Text marginBottom={7} marginTop={2}>
            <Link as={NavLink} to="/forgotpage" color="blue.500">
              Forgot Password?
            </Link>
          </Text>
        </Flex>
        <Button onClick={login} colorScheme="blue">
          Login with Email
        </Button>
        <Text margin={3}>Or</Text>
        <Button onClick={googleSignin} colorScheme="red" marginBottom="2">
          Sign in with Google
        </Button>
        <Text fontSize={14} marginTop={5}>
          New to Astroworkers?{" "}
          <Link as={NavLink} to="/signup" color="blue.500">
            create an account
          </Link>{" "}
          to get started today
        </Text>
      </Flex>
    </Flex>
  );
}
